module.exports = __webpack_public_path__ + "static/media/customer-mcdonalds.95308fb3.png";